module.exports = __webpack_public_path__ + "static/media/on_the_go_mom.5f87faf7.png";